import React from 'react'

import cx from 'classnames'
import { compactInteger } from 'humanize-plus'

import styles from './styles.module.css'

interface Props {
  children: React.ReactNode
  selected: boolean
  count?: number
  onClick: () => void
}

const SelectionPill: React.FC<Props> = ({ children, selected, onClick, count }): JSX.Element => {
  return (
    <div onClick={onClick} className={cx(styles.selectionPill, { [styles.selected]: selected })}>
      {`${count !== undefined ? compactInteger(count) : ''} ${children}`}
    </div>
  )
}

export default SelectionPill
